interface IBaseObjectBookingApiResponseModel {
    messages: string[];
    success: boolean;
}

//AvailablePeriod
export interface AvailablePeriod {
    bookingObjectId: string;
    bookingObjectName: string;
    startDate: string | null;
    endDate: string | null;
    price: number;
    bookingFee: number;
    bookedDays: number;
}

export interface IAvailablePeriodDetails {
    startDate: Date;
    endDate: Date;
    totalPrice: number;
    price: number;
    pricePerDay: number;
    bookingFee: number;
    totalDays: number;
}

export interface IAvailablePeriodsResponseModel {
    success: boolean;
    messages: string[];
    availablePeriods: AvailablePeriod[];
}

//BookingObject
export interface IBookingObjectResponseModel extends IBaseObjectBookingApiResponseModel {
    bookingObject: IBookingObjectModel;
}

export interface IBookingObject {
    id: string;
    name: string;
    description: string;
    bookingGroup: IBookingGroup;
    addons: IAddon[];
}

export interface ICabinBookingObject extends IBookingObject {
    availablePeriod: AvailablePeriod;
}

interface IAddon {
    id: string;
    name: string;
    quantity: number;
}

export interface IBookingGroup {
    id: string;
    name: string;
}

//Booking
export interface IUserBookingsResponseModel extends IBaseObjectBookingApiResponseModel {
    bookings: IDetailedBooking[];
}

export interface IDetailedBooking extends IBaseBooking {
    id: string;
    name: string;
    bookingObjectId: string;
    addons: IAddon[];
    startDate: string;
    endDate: string;
    bookingFee: number;
    totalPrice: number;
    status: string;
    statusReason: string;
}

export interface IBaseBooking {
    id: string;
    name: string;
    bookingObjectId: string;
    addons: IAddon[];
    startDate: string;
    endDate: string;
    bookingFee: number;
    totalPrice: number;
    status: string;
    statusReason: string;
    bookingObject: IBookingObject;
}

export class BookingStatus {
    static Active = 'Aktiv';
    static Inactive = 'Inaktiv';
}

export class BookingStatusReason {
    static Canceled = 'Avbokad';
}

export enum BookingTimelineStatus {
    Upcoming,
    Previous,
    Canceled,
}

export interface IAvailableBookingsQueryState {
    objectIds?: string[];
    startDate?: Date;
    endDate?: Date;
}

export interface IBookingObjectModel {
    id: string;
    bookingGroup: IBookingGroup;
    availablePeriod?: AvailablePeriod;
}
